import { render } from "./ActionsComponent.vue?vue&type=template&id=2d4e7523&scoped=true"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"

import "./ActionsComponent.vue?vue&type=style&index=0&id=2d4e7523&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4e7523"]])

export default __exports__